import { render, staticRenderFns } from "./userRechargeBlack.vue?vue&type=template&id=6cff38be&scoped=true&"
import script from "./userRechargeBlack.vue?vue&type=script&lang=js&"
export * from "./userRechargeBlack.vue?vue&type=script&lang=js&"
import style0 from "./userRechargeBlack.vue?vue&type=style&index=0&id=6cff38be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cff38be",
  null
  
)

export default component.exports